/* Global imports. */
import React from "react";

/* Other imports. */
import { useSiteMetadata } from "@src/hooks/useSiteMetaData"
import { websiteURLs } from "@src/constants";
import icon from "@images/icon--facebook.svg";

export const altText = "Share on Facebook";

interface Props {
  slug: string;
}

const ShareOnFacebook = ({ slug }: Props) => {
  const { siteRoot } = useSiteMetadata()

  const markup = (
    <a
      href={`${websiteURLs.facebook.share}${siteRoot}/${slug}`}
      target="_blank"
      rel="noreferrer"
      data-social="Facebook"
      className="block w-12 h-12 mb-2 mr-4"
    >
      <img src={icon} alt={altText} title={altText} className="max-w-[100%] max-h-12" />
    </a>
  );

  return slug ? markup : null;
};

export default ShareOnFacebook;
